export const HIDE_MTO_ADD_TO_CART_ERROR = 'HIDE_MTO_ADD_TO_CART_ERROR';
export const SHOW_MTO_ADD_TO_CART_ERROR = 'SHOW_MTO_ADD_TO_CART_ERROR';
export const BEGIN_MTO_ADD_TO_CART = 'BEGIN_MTO_ADD_TO_CART';

export function hideMTOAddToCartError(component, event) {
    return {
        type: HIDE_MTO_ADD_TO_CART_ERROR,
        meta: {
            component: component,
            event: event
        }
    };
}

export function showMTOAddToCartError(component, event, errorCode, errorPrefix = 'ERROR_PRODUCT') {
    return {
        type: SHOW_MTO_ADD_TO_CART_ERROR,
        meta: {
            component: component,
            event: event
        },
        payload: {
            error: `${errorPrefix}_${errorCode}`
        }
    };
}

export function beginMTOAddToCart(component, event) {
    return {
        type: BEGIN_MTO_ADD_TO_CART,
        meta: {
            component: component,
            event: event
        }
    };
}
